export default "__VITE_ASSET__BR7VMJCP__"